/**
 * C-65 Mobile and Tablet "Load More" Button Functionality for Multiple Instances
 */

// Select all containers with the class .adm-div-c65-card-container
const c65BlockInstances = document.querySelectorAll(".adm-div-c65-card-container");

// Reusable function to handle "Load More" button clicks
function handleLoadMore(button, hiddenClass, increment, cardContainer, currentlyDisplayedCount, totalCards) {
    button.addEventListener("click", function () {
        const hiddenCards = cardContainer.querySelectorAll(`.c65-card-item.${hiddenClass}`);
        for (let i = 0; i < increment && i < hiddenCards.length; i++) {
            hiddenCards[i].classList.remove(hiddenClass);
        }

        currentlyDisplayedCount += increment;

        if (currentlyDisplayedCount >= totalCards) {
            button.style.display = "none"; // Hide the button if all cards are displayed
        }
    });
}

c65BlockInstances.forEach(function (cardContainer) {
    // Initialize display count
    const totalCards = cardContainer.querySelectorAll(".c65-card-item").length;

    // Set increment defaults, Can Be Overridden by data-increment attribute in template
    let mobileIncrement = 3;
    let tabletIncrement = 4;

    // Select buttons individually    
    const loadMoreButtonMobile = cardContainer.parentElement.querySelector(".adm-btn-c65-load-more.adm-div-c65-load-more-mobile");
    const loadMoreButtonTablet = cardContainer.parentElement.querySelector(".adm-btn-c65-load-more.adm-div-c65-load-more-tablet");

    // Handle mobile button
    if (loadMoreButtonMobile) {
        mobileIncrement = Number(loadMoreButtonMobile.getAttribute("data-increment")) || mobileIncrement;
        handleLoadMore(loadMoreButtonMobile, "c65-mobile-hidden", mobileIncrement, cardContainer, mobileIncrement, totalCards);
    }

    // Handle tablet button
    if (loadMoreButtonTablet) {
        tabletIncrement = Number(loadMoreButtonTablet.getAttribute("data-increment")) || tabletIncrement;
        handleLoadMore(loadMoreButtonTablet, "c65-tablet-hidden", tabletIncrement, cardContainer, tabletIncrement, totalCards);
    }
});
